var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame"},[(_vm.ready)?_c('iframe',{staticClass:"frame-iframe",attrs:{"src":_vm.src,"frameborder":"0"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }